import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getConversionsOverTime = (days: number, selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/conversions-over-time/${days}?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}

export default getConversionsOverTime;